import { MainImages } from '@lemon/assets';
import { headers } from '../../layout/header/Header';

export const Pouch = () => {
    return (
        <figure
            id={headers[3].id}
            className="relative w-full h-full flex flex-col items-center justify-center bg-white text-black pt-[180px] px-4"
        >
            <div className="w-full flex flex-col items-start xl:pl-[800px]">
                <div className="text-[60px] md:text-[100px] lg:text-[120px] font-bold text-balance font-montserrat">
                    {title}
                </div>

                {/* Mobile: 이어진 텍스트 */}
                <div className="md:hidden flex flex-col gap-4 mt-6">
                    <p className="text-[14px] text-[#666] leading-relaxed text-left">
                        {description1_1} {description1_2}
                    </p>
                    <p className="text-[14px] text-[#666] leading-relaxed text-left">
                        {description2_1} {description2_2} {description2_3} {description2_4}
                    </p>
                </div>

                {/* Desktop: 분리된 텍스트 */}
                <div className="hidden md:flex md:flex-col md:items-start md:gap-0">
                    <div className="flex flex-col gap-[10px] mt-10">
                        <div className="text-[18px] lg:text-[20px] text-[#666] text-pretty leading-relaxed max-w-[800px] text-left">
                            {description1_1}
                        </div>
                        <div className="text-[18px] lg:text-[20px] text-[#666] text-pretty leading-relaxed max-w-[800px] text-left">
                            {description1_2}
                        </div>
                    </div>

                    <div className="flex flex-col gap-[10px] mt-[30px]">
                        <div className="text-[18px] lg:text-[20px] text-[#666] text-pretty leading-relaxed max-w-[900px] text-left">
                            {description2_1}
                        </div>
                        <div className="text-[18px] lg:text-[20px] text-[#666] text-pretty leading-relaxed max-w-[900px] text-left">
                            {description2_2}
                        </div>
                        <div className="text-[18px] lg:text-[20px] text-[#666] text-pretty leading-relaxed max-w-[900px] text-left">
                            {description2_3}
                        </div>
                        <div className="text-[18px] lg:text-[20px] text-[#666] text-pretty leading-relaxed max-w-[900px] text-left">
                            {description2_4}
                        </div>
                    </div>
                </div>
            </div>

            <img
                src={MainImages.pouch_content}
                alt="pouch"
                onDragStart={e => e.preventDefault()}
                className="w-full max-w-[1200px] mt-10 md:mt-16 self-center"
            />
        </figure>
    );
};

const title = 'pouch';
const description1_1 = `EPYT는 화장품 파우치 속 제품 데이터를 수집하여,`;
const description1_2 = `개인의 특성·취향·구매행동 간 상관관계를 정량적으로 분석합니다.`;

const description2_1 = '이를 바탕으로 소비자가 실제 사용하는 제품 조합에서 얻은 인사이트를 도출하며,';
const description2_2 = 'EPYT만의 알고리즘으로 세분화된 사용자 군집을 정의해 더욱 정확한';
const description2_3 = '타깃 세그멘테이션을 수행합니다. 마지막으로, 분석 결과를 기반으로 사용자';
const description2_4 = '개개인에게 최적화된 개인화 큐레이션을 제공합니다.';
